import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

const UserInputWrapper = (Component) => {
    return class extends React.PureComponent {
        constructor(props) {
			super(props);
		}
        render() {
            return <Component {...this.props} />;
        }
    };
};

const mapStateToProps = (state) => ({
    inputType: state.ui.inputType
});

export default compose(
    connect(mapStateToProps, null),
    UserInputWrapper
);
